import "./Home.module.css";
import Header from "@/reusable_sections/Header";
import ProfessionalStreamingInBcnVlc from "./sections/ProfessionalStreamingInBcnVlc";
import OurSignatureCreations from "./sections/OurSignatureCreations";
import Testimonials from "./sections/Testimonials";
import OurVenuePartners from "./sections/OurVenuePartners";
import GamingSocialFooter from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div>
      <Header />
      <OurVenuePartners />
      <Testimonials />
      <ProfessionalStreamingInBcnVlc />
      <OurSignatureCreations />
      <GamingSocialFooter />
    </div>;
}